<template lang="pug">
  self-search(
    v-if="$get(topBar, `search`)"
    :top-bar="topBar")
  v-app-bar.no-radius-top(
    v-else
    v-glass=".85"
    app
    :value="!!topBar"
    :elevation="window.scrollY === 0 ? 1 : 4"
    :style="$theme.dark ? `background: #000` : `background: #fff`"
    :color="window.scrollY === 0 ? $get(topBar, `color`) : undefined")
    template(v-if="topBar")
      v-app-bar-nav-icon.ml-1(
        style="z-index: 10"
        v-if="topBar.onBack !== null"
        @click="onBack")
        v-icon(title="back") {{ mdiChevronLeft }}
      v-toolbar-title(
        :style="center ? `position: absolute; text-align: center; padding: 0;` : undefined"
        :class="$get(topBar, `center`) ? `text-center` : undefined"
        style="width: 100%") {{ topBar.title }}
</template>

<script>
import { state } from '..'
import { toRefs } from '@vue/composition-api'
import { mdiChevronLeft } from '@mdi/js'
import { prioritiesGlobal } from '@iez/core/app/set-priority/'
import router, { routeCurrent } from '@iez/core/router/'
import { computed } from '@vue/composition-api'
import useWindow from '@iez/lib/use-window'
import SelfSearch from './search/'

export default {
  components: {
    SelfSearch
  },

  props: {
    center: Boolean
  },

  setup () {
    const onBack = () => {
      router.back()
    }

    return {
      mdiChevronLeft,
      ...toRefs(state),
      window: useWindow(),
      onBack
    }
  }
}
// 4 16
</script>

<style scoped>
* >>> .v-app-bar.v-sheet {
  border-top-right-radius: 0 !important;
  border-top-left-radius: 0 !important;
}
* >>> .v-toolbar__content {
  padding: 0;
}
</style>
